import {createRouter, createWebHistory} from 'vue-router';

// import DashboardSettings from '../components/routes/DashboardSettings'
import Applayouts from '../components/layouts/app.layouts.vue'
import Dashboardlayouts from '../components/layouts/dashboard.layouts.vue'
 const routes=[
    // {
    //     path: '*',
    //     redirect: '/'
    // },
    {
        path:"/",
        name:"/",
        component: Applayouts,
        children:[
            {
                path: "/",
                name: "login",
                component:()=>import('../pages/auth/login.page')
            },
        ]
    },
    {
        path: "/",
        name: "page",
        component: Dashboardlayouts,
        meta: {
            required: true,
            roles: ["user", "superadmin", "admin","guardia"],
        },
        children:[
            {
                path: "/dashboard",
                name: "dashboard",
                // component:()=>import('../pages/admin/dashboard.page.vue'),
                component:()=>import('../pages/admin/publicity/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/users",
                name: "users",
                component:()=>import('../pages/admin/users/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/companies",
                name: "companies",
                component:()=>import('../pages/admin/companies/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["superadmin", "admin"],
                },
            },
            {
                path: "/products",
                name: "products",
                component:()=>import('../pages/admin/products/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["superadmin", "admin"],
                },
            },
            {
                path: "/product-categories",
                name: "product-categories",
                component:()=>import('../pages/admin/products/categories.page.vue'),
                meta: {
                    required: true,
                    roles: ["superadmin", "admin"],
                },
            },
            {
                path: "/publicity",
                name: "publicity",
                component:()=>import('../pages/admin/publicity/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/publicity",
                name: "publicity",
                component:()=>import('../pages/admin/publicity/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/events",
                name: "events",
                component:()=>import('../pages/admin/events/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/videos",
                name: "videos",
                component:()=>import('../pages/admin/videos/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/groups",
                name: "groups",
                component:()=>import('../pages/admin/groups/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/category",
                name: "category",
                component:()=>import('../pages/admin/category/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/configuration",
                name: "configuration",
                component:()=>import('../pages/admin/configuration/homeMovil.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/interest",
                name: "interest",
                component:()=>import('../pages/admin/interest/interest.page.vue'),
                meta: {
                    required: true,
                    roles: ["user", "superadmin", "admin","guardia","almacen"],
                },
            },
            {
                path: "/roles",
                name: "roles",
                component:()=>import('../pages/admin/roles/index.page.vue'),
                meta: {
                    required: true,
                    roles: ["superadmin", "admin"],
                },
            }
        ]
    },
];

const router =createRouter(
    {
        history: createWebHistory(),
        routes
});
router.beforeEach((to, from, next) => {
    if (to.meta) {
        if(to.path=='/'){
            const token = localStorage.getItem("token") ;
            if(token){
                router.push("/dashboard");
            }
            else{
                next();
            }
        }
        else if (to.meta.required) {
            const user = JSON.parse(localStorage.getItem("user") || null);
            const token = localStorage.getItem("token") ;
            if (user) {
                if (token) {
                    
                    if (to.meta.roles) {
                        let access = false;
                        for (let index = 0; index < to.meta.roles.length; index++) {
                            const element = to.meta.roles[index];
                            if (user.rol.includes(element)) {
                                access = true;
                            }
                        }
                        if (access) {
                            next();
                        } else {
                            router.push("/");
                        }
                    }
                    next();
                } else {
                    router.push("/");
                }
            }
            else {
                router.push("/");
            }
        }
    }
    next();
});
    
export default router;
